import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import { useSelector } from "react-redux";
import Visual from "./components/Visual";
import Spinner from "../Spin/Spinner";
import { getBerleenUploadData } from "../../config/LiveApi";

const PayinUpload = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [tableData, setTableData] = useState([]);
  const [userList, setUserList] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [payoutData, setPayoutData] = useState([]);
  const [payinSettlementData, setPayinSettlementData] = useState(null);

  useEffect(() => {

    const fetchBerleenData = async () => {
      try {
        setIsLoading(true);

        const response = await getBerleenUploadData(
          token,
          startDate,
          endDate
        );

        console.log("Berleen Upload Data:", response);

        setTableData(response.formatted || []);
        setPayoutData(response.userData || []);
        setPayinSettlementData(
          response.payinAndSettlementData || null
        );
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBerleenData();
  }, [startDate, endDate]);
  return (
    <>
       <Header
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
       {isLoading ? (
        <Spinner />
      ) : (
        <Visual
          tableData={tableData}
          payoutData={payoutData}
          payinSettlementData={payinSettlementData}
          setTableData={setTableData}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default PayinUpload;
